var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivateModeOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_18694",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.098
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19095",
    "data-name": "Rectangle 19095",
    width: 31,
    height: 31,
    transform: "translate(-199 -142)",
    fill: "#3d7cc9",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Private_mode_on",
    "data-name": "Private mode on",
    transform: "translate(-1706 -72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1706, 72)",
    filter: "url(#Rectangle_18694)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18694-2",
    "data-name": "Rectangle 18694",
    width: 50,
    height: 50,
    rx: 4,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Private",
    transform: "translate(1924 230)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-199 -139.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10193",
    "data-name": "Group 10193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26391",
    "data-name": "Path 26391",
    d: "M6.477,8.261H24.523L22.6.6s-.117-.869-1.621-.517-5.169,1.01-5.169,1.01A6.159,6.159,0,0,1,12.375.836C10.448.155,9.132-.033,9.038.108Z",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26392",
    "data-name": "Path 26392",
    d: "M0,13.6H31A30.511,30.511,0,0,0,0,13.6Z",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26393",
    "data-name": "Path 26393",
    d: "M21.656,15.436a5.122,5.122,0,0,0-5.091,4.558v0H14.46v.333A5.122,5.122,0,1,0,9.344,25.68a5.07,5.07,0,0,0,5.116-4.89v0H16.54a5.122,5.122,0,0,0,5.116,4.886,5.122,5.122,0,1,0,0-10.245ZM9.344,24.6a4.041,4.041,0,1,1,4.042-4.041A4.042,4.042,0,0,1,9.344,24.6Zm12.312,0A4.041,4.041,0,1,1,25.7,20.558,4.042,4.042,0,0,1,21.656,24.6Z",
    fill: "#3d7cc9"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateModeOn);
export default __webpack_public_path__ + "static/media/private_mode_on.16a9e6d4b7de22c471eae84a13b131f4.svg";
export { ForwardRef as ReactComponent };